import { useLocalStore } from 'mobx-react-lite';
import { useEffect } from 'react';

import { previewBuilder, uploader } from '@gem/modules/file-upload';

export default ({ userFile }) => {
  const presenter = useLocalStore(() => ({
    userFile: null,
    uploadProgress: null,
    url: null,
    previewUrl: null,
    error: null,
    uploadUrl: null,

    upload: async () => {
      if (!userFile) {
        return;
      }

      presenter.error = false;
      presenter.uploadProgress = 0;

      if (!presenter.url) {
        try {
          const { publicUrl, uploadUrl, headers } = await uploader.getUploadUrlData(
            userFile.filename,
            userFile.type
          );

          presenter.uploadUrl = uploadUrl;

          await uploader.uploadFile(uploadUrl, userFile, userFile.filename, headers, (event) => {
            presenter.uploadProgress = (event.loaded / event.total) * 100;
          });

          if (['video'].includes(userFile.type.split('/')[0])) {
            presenter.previewUrl = await previewBuilder.getFilePreviewUrl(
              userFile,
              userFile.filename
            );
          }

          presenter.url = publicUrl;
          presenter.userFile = null;
        } catch (e) {
          presenter.error = true;
          presenter.uploadProgress = 0;
          return;
        }
      }

      presenter.uploadProgress = null;
    },

    cancelUpload: () => {
      if (presenter.uploadUrl) {
        uploader.cancelUploadFile(presenter.uploadUrl);
      }
    },

    reUpload: () => {
      presenter.upload();
    },
  }));

  useEffect(() => {
    presenter.userFile = userFile;
    presenter.upload();
  }, [userFile]);

  return presenter;
};
